import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import './modal.css'
import { GC_USER_ID } from '@/constants'
import { groupsQuery } from '@/graphql/queries/group'
import { deleteGroup } from '@/graphql/mutations/group'
import { addToRoutinesOnGroup } from '@/graphql/mutations/routine'

import { Modal, Typography, Paper, GridList, GridListTile } from 'material-ui'
import List, { ListItem, ListItemText } from 'material-ui/List'
import EditIcon from 'material-ui-icons/Edit'
import IconButton from 'material-ui/IconButton'
import ClearIcon from 'material-ui-icons/Clear'
import Loading from './Loading'
import GroupEditModal from './GroupEdit'

import * as moment from 'moment'

@graphql(groupsQuery, {
  name: 'groupsQuery',
  options: () => ({
    variables: {
      userId: global.localStorage.getItem(GC_USER_ID)
    },
    refetchQueries: ['groupsQuery']
  })
})
@graphql(deleteGroup, {
  name: 'deleteGroup',
  options: {
    refetchQueries: ['groupsQuery']
  }
})
@graphql(addToRoutinesOnGroup, {
  name: 'addToRoutinesOnGroup',
  options: {
    refetchQueries: ['routineQuery', 'routinesQuery']
  }
})
export default class GroupsModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      groups: '',
      openEdit: false,
      action: '',
      id: '',

      loadingDel: false,
      OpenDelete: false,

      loading: false
    }
  }

  // reset state if the seeded prop is updated
  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.props.open) {
      this.setState({ open: nextProps.open })
    }
    if (nextProps.routine !== this.props.routine) {
      if (nextProps.routine) {
        if (nextProps.routine.groups && nextProps.routine.groups.length > 0) {
          var g = []
          nextProps.routine.groups.forEach(e => g.push(e.id))
          this.setState({ groups: g })
        }
      }
    }
  }

  handleClose = () => {
    this.props.onClose()
    this.setState({
      open: false
    })
  }

  handleEdit = (action, id) => {
    this.setState({ action: action })
    if (action === 'edit') {
      this.setState({ id: id })
    } else if (action === 'add') {
      this.setState({ id: '' })
    }
    this.setState({ openEdit: true })
  }

  handleCloseEdit = () => {
    this.setState({ openEdit: false })
  }

  handleAddTo = id => {
    this.setState({ loading: true })
    this.props
      .addToRoutinesOnGroup({
        variables: {
          routinesRoutineId: this.props.id,
          groupsGroupId: id
        }
      })
      .then(() => {
        this.props.onClose()
        this.setState({
          open: false,
          loading: false
        })
      })
      .catch(error => {
        console.log(error.message + ' Please refresh.')
        this.props.onClose()
        this.setState({
          open: false,
          loading: false
        })
      })
  }

  handleOpenDelete = () => {
    this.setState({
      OpenDelete: true
    })
  }

  handleCloseDelete = () => {
    this.setState({
      OpenDelete: false
    })
  }

  handleDelete = id => {
    this.setState({ loadingTracker: true, loadingDel: true })
    this.props
      .deleteTracker({
        variables: {
          id: id
        }
      })
      .then(() => {
        this.props.onClose()
        this.setState({
          loadingDel: false,
          OpenDelete: false,
          open: false
        })
      })
      .catch(error => {
        console.log(error.message + ' Please refresh.')
        this.props.onClose()
        this.setState({
          loadingDel: false,
          OpenDelete: false,
          open: false
        })
      })
  }

  render() {
    return (
      <div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleClose}
          className="modalAddToday"
          disableAutoFocus
        >
          <Paper className="paperAddToday" style={{ borderRadius: 16 }}>
            {this.state.loading ? (
              <Loading />
            ) : this.props.groupsQuery.loading ? (
              <Loading />
            ) : (
              <div id="GetUpTime" className="divAddTpday">
                <List>
                  <ListItem divider>
                    <ListItemText
                      className="modalHealder"
                      primary={
                        <Typography
                          variant="body1"
                          style={{ fontSize: 18, color: 'grey' }}
                        >
                          Your tracker groups
                        </Typography>
                      }
                    />

                    <IconButton
                      className="btn btn-default btn-style"
                      onClick={this.handleClose}
                    >
                      <ClearIcon className="iconClear" />
                    </IconButton>
                  </ListItem>
                </List>
                {
                  <GridList className="gridList" cols={4}>
                    {this.props.groupsQuery.allGroups
                      .filter(e => !this.state.groups.includes(e.id))
                      .map((e, index) => (
                        <GridListTile
                          xs={6}
                          cols={1}
                          key={index}
                          style={{ height: 108 }}
                        >
                          <Paper
                            className="paperBlock"
                            style={{ borderRadius: 36 }}
                          >
                            <div
                              key={`bookblock-key-${index}`}
                              onClick={() => this.handleAddTo(e.id)}
                              className="bookBlockChecked"
                              style={{
                                backgroundColor: e.color,
                                opacity: 0.55
                              }}
                            >
                              <img
                                alt=""
                                className="iconTracker"
                                src={process.env.PUBLIC_URL + '/cloud_done.png'}
                              />
                              <Typography
                                variant="caption"
                                style={{
                                  paddingLeft: 2,
                                  paddingRight: 2,
                                  textAlign: 'center',
                                  fontSize: 12,
                                  color: 'white',
                                  lineHeight: 1.1
                                }}
                              >
                                {e.name}
                              </Typography>
                            </div>
                            <div
                              onClick={() => this.handleEdit('edit', e.id)}
                              className="iconBtnEditSmallX"
                            >
                              <EditIcon
                                style={{
                                  color: 'lightgrey',
                                  fontSize: 14
                                }}
                              />
                            </div>
                          </Paper>
                        </GridListTile>
                      ))}
                    <GridListTile
                      xs={6}
                      cols={1}
                      key={'add'}
                      style={{ height: 90 }}
                    >
                      <Paper
                        className="paperBlock"
                        style={{ borderRadius: 36 }}
                        onClick={() =>
                          this.handleEdit('add' + moment().second(), '')
                        }
                      >
                        <div
                          key={`bookblock-key-add`}
                          className="bookBlockChecked"
                          style={{ backgroundColor: 'white' }}
                        >
                          <img
                            alt=""
                            className="iconTracker"
                            src={process.env.PUBLIC_URL + '/cloud_done.png'}
                          />
                          <Typography
                            variant="body1"
                            id="bookName"
                            style={{
                              paddingLeft: 2,
                              paddingRight: 2,
                              textAlign: 'center',
                              fontSize: 12,
                              color: 'grey',
                              lineHeight: 1.1
                            }}
                          >
                            Add
                          </Typography>
                        </div>
                      </Paper>
                    </GridListTile>
                  </GridList>
                }
              </div>
            )}
          </Paper>
        </Modal>
        <GroupEditModal
          open={this.state.openEdit}
          onClose={this.handleCloseEdit}
          id={this.state.id}
          action={this.state.action}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/Groups.js